import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UserService } from "../../../services/user.service";
import { MessageDefinitionService } from "../../../services/messages.service";
import { ServiceRequestType } from "../../../models/service-request-type";
import { MessageDefinition } from "../../../models/message-definition";
import { MatSort } from "@angular/material/sort";
import { Settings } from "../../../services/settings";
import { DataRecord } from "../../requests/commands/req-status/req-status.component";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { GeneralSetting } from 'src/app/models/generalsetting';

class AppEventMessages {
	id: number;
	eventDescription: string;
	messageId: number;
	messageDescription: string;
	subject: string;
	category: string;
	activeStatus: string;

	constructor(id: number, evdesc: string, messageId: number, msgDesc: string, subject: string, category: string, activeStatus: string) {
		this.id = id;
		this.eventDescription = evdesc;
		this.messageId = messageId;
		this.messageDescription = msgDesc;
		this.subject = subject
		this.category = category;
		this.activeStatus = activeStatus;
	}
}
@Component({
	selector: 'app-automated-emails',
	templateUrl: './automated-emails.component.html',
	styleUrls: ['./automated-emails.component.css']
})
export class AutomatedEmailsComponent implements OnInit {

	public formTitle = 'Automated E-mails';
	public pagination: string;
	public busyCursor: boolean = false;
	public messageBodyDlg: boolean = false;
	public messageBody: any | null = '';

	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	public enabledList: any;
	public selectedValue: string;
	public settingsRecord: any;
	public currentRunState: string;
	public editMode: boolean = false;

	public displayedColumns: string[] = ['id', 'eventDescription', 'messageId', 'messageDescription', 'subject', 'category', 'activeStatus'];
	public dataSource: MatTableDataSource<any>;
	public Idx = -1;

	public messageDefs: any
	public appEvents: any;
	public selectedRecord: any;
	public records: any;

	public fetchedMessageDefs = false;
	public fetchedAppEvents = false;
	public messageDropDownItems: any
	public noMessage: string = '- No Message -';
	public enableEmail = false;
	enableEmailSetting: GeneralSetting;
	public visibleModify: boolean = false;

	constructor(public settingsService: UserService, public messagesService: MessageDefinitionService) {
		this.enabledList = [];
		this.enabledList.push({ id: 'true', description: 'Enabled' });
		this.enabledList.push({ id: 'false', description: 'Disabled' });

	}

	@ViewChild(MatSort, { static: true }) sort: MatSort;

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege("SETTINGS_AUTOMATED_EMAILS", "WRITE")) {
			this.visibleModify = true;
		}
		/** start the daisy chain **/
		this.queryMessageDefs();
		this.enableEmailSetting = Settings.getInstance().getGeneralSettingByKey('EnableEmail');
		if (this.enableEmailSetting && this.enableEmailSetting !== undefined && this.enableEmailSetting !== null && this.enableEmailSetting.value === 'true') {
			this.enableEmail =true;
		} else{
			this.enableEmail = false;
		}
	}
	public queryMessageDefs(): void {

		if (!this.fetchedMessageDefs) {
			this.fetchedMessageDefs = true;
			this.messagesService.getAllMessageDefinitions().subscribe(
				(results) => {
					this.messageDropDownItems = [];
					this.messageDropDownItems.push(new DataRecord(0, this.noMessage));
					this.messageDefs = results;

					for (let rec of this.messageDefs) {
						if (rec.activeStatus == 'Active')
							this.messageDropDownItems.push(new DataRecord(rec.id, rec.description));
					}

					this.queryApplicationEvents();
				},
				(error) => {
					Settings.getInstance().handleError(error, 'Fetching active message definitions');
				});
		}
		else {
			this.queryApplicationEvents();
		}
	}
	public applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public clearFilter() {
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public queryApplicationEvents() {

		if (!this.fetchedAppEvents) {
			this.messagesService.getAllApplicationEvents().subscribe(
				(results) => {
					this.appEvents = results.filter((event: any) => !event.eventCode.startsWith("REQUEST_STATUS_"));
					this.queryMessageEvents();
				},
				(error) => {
					Settings.getInstance().handleError(error, 'Fetching application events');
				});
		}
		else {
			this.queryMessageEvents();
		}
	}
	public queryMessageEvents() {
		this.records = [];
		this.messagesService.getAllMessageEvents().subscribe(
			(results) => {
				for (let rec of this.appEvents) {
					const msgEv = results.find(s => s.applicationEventId === rec.id)
					let appEvId = rec.id;
					let messageId = 0;
					let messageDesc = '';
					let messageRec = null;

					if (msgEv !== undefined) {
						messageId = msgEv.messageId;
						appEvId = msgEv.applicationEventId;
						let md = this.messageDefs.find(s => s.id === messageId);

						if (md !== undefined) {
							messageDesc = md.description;
							if (md.activeStatus != 'Active') {
								messageDesc += ' (In-Active)';
							}
							this.records.push(new AppEventMessages(appEvId, rec.description, messageId, messageDesc, md.subject, md.messageCategory, rec.activeStatus));
						}
					} else {
						messageId = 0;
						messageDesc = this.messageDropDownItems.find(s => s.id === messageId).description;
						this.records.push(new AppEventMessages(appEvId, rec.description, messageId, messageDesc, "", "", rec.activeStatus));
					}
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.setPagination(-1, this.records.length);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching message events');
			}
		)

	}
	public tableKeyDown(event: KeyboardEvent) {
		if (this.editMode) {
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.selectRow();
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.selectRow();

			}
		}
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.messageBody = this.messageDefs.find(rec => rec.id == this.selectedRecord.messageId)?.messageBody;
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {
		this.Idx = -1;
		this.selectedRecord = new ServiceRequestType();
	}
	@HostListener('matSortChange', ['$event'])
	onSortChange(event: any) {

		if (this.editMode) {
			event.preventDefault();
			return;
		}

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;

		this.selectRow();

	}
	public onRowClicked(selected: any) {

		if (this.editMode) {
			return;
		}

		this.selectedRecord = selected;
		this.selectRow();
	}
	public onMessageChange(record: any): void {

		let md: MessageDefinition = this.messageDefs.find(rec => rec.id == record.messageId);

		if (md === undefined) {
			md = new MessageDefinition();
			md.description = this.noMessage;
		}

		this.records[this.Idx].messageDescription = md.description;
		this.records[this.Idx].subject = md.subject;
		this.records[this.Idx].category = md.messageCategory;
		this.records[this.Idx].activeStatus = md.activeStatus;

		this.messagesService.updateMessageEvent(record.id, record.messageId).subscribe(
			(result) => {
				/* do nothing */
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Updating message events');
			}
		)
	}
	public returnMessageColor(id: number, msgDesc: string = ""): string {

		if (msgDesc && msgDesc.indexOf("(In-Active)") != -1) {
			return 'gray';
		}
		if (id > 0) {
			return 'green';
		}

		return 'gray';
	}
	public doDialogMessageBody() {
		this.messageBodyDlg = true;
	}
	public doMessageDetailSubmit(event: any): void {
		this.messageBody = event;
		this.messageBodyDlg = false;
		let messageDef: MessageDefinition = this.messageDefs.find(rec => rec.id == this.selectedRecord.messageId);
		if (!messageDef) {
			return;
		}
		messageDef.messageBody = this.messageBody;
		this.messagesService.updateMessageDefinition(messageDef).subscribe(
			(result) => {

			},
			(error) => {
				Settings.getInstance().handleError(error, 'Updating message definition');
			}
		);
	}

	public onStatusChange(): void {
		let appEv = this.appEvents.find(rec => rec.id == this.selectedRecord.id);
		appEv.activeStatus = this.selectedRecord.activeStatus;
		this.messagesService.updateApplicationEvent(appEv).subscribe((result) => {

		},
			(error) => {
				Settings.getInstance().handleError(error, 'Updating application event');
			}
		);
	}
}
